import * as React from "react";

const StatusInProgress = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#F8F43F" />
    </svg>
);

export default StatusInProgress;
